import React from 'react'
import { bindActionCreators } from 'redux'
import { Route, Redirect, Switch } from 'react-router-dom'
import Login from '../login'
import Home from '../home'
import Orders from '../orders'
import Menu from '../menu'
import Dashboard from '../dashboard'
import { connect } from 'react-redux'

class App extends React.Component {
  render() {
    return (
      <div>
        <main>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route
              exact
              path="/membershipSuccess/:membershipId"
              component={Home}
            />
            <Route
              exact
              path="/membershipFailure/:membershipId"
              component={Home}
            />
            <PrivateRoute
              from="/dashboard"
              component={Dashboard}
              userLoggedIn={this.props.userLoggedIn}
            />
            <PrivateRoute
              from="/orders"
              component={Orders}
              userLoggedIn={this.props.userLoggedIn}
            />
            <PrivateRoute
              from="/menu"
              component={Menu}
              userLoggedIn={this.props.userLoggedIn}
            />
            <PrivateRoute
              from="/"
              component={Home}
              userLoggedIn={this.props.userLoggedIn}
            />
            {/*<PrivateRoute from="/membershipSuccess/:membershipId" component={Home} userLoggedIn={this.props.userLoggedIn}/>
            <PrivateRoute from="/membershipFailure/:membershipId" component={Home} userLoggedIn={this.props.userLoggedIn}/>*/}
          </Switch>
        </main>
      </div>
    )
  }
}

function PrivateRoute({ component: Component, userLoggedIn, from }) {
  return (
    <Route
      render={props => {
        return userLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            component={Login}
            from={from}
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }}
    />
  )
}

const mapStateToProps = ({ admin }) => ({
  admin: admin,
  userLoggedIn: admin.userLoggedIn
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
